/* ============================================================================
 * Project        : Deloitte Digital Compliance
 * File           : VehicleComponents.jsx
 * Version        : 1.0.0
 * Author         : Team Neubinary
 * Created On     : 2026-06-24
 *
 * Description    : Digital Compliance for Automation and Governance
 *
 * Change History :
 * ----------------------------------------------------------------------------
 * Date         | Version | Author           | Description
 * ----------------------------------------------------------------------------
 * 2026-06-24   | 1.0.0   | Team Neubinary   | Initial creation
 * <YYYY-MM-DD> | x.x.x   | <Name/Team>      | <Change description>
 * ============================================================================
 *
 * Copyright (c) 2026 AU79 Consulting Services Pvt. Ltd.
 * All Rights Reserved.
 *
 * This source code and its contents are confidential and proprietary to
 * AU79 Consulting Services Pvt. Ltd. Unauthorized copying, reproduction,
 * modification, distribution, or disclosure of this material, in whole or
 * in part, is strictly prohibited without prior written permission from
 * AU79 Consulting Services Pvt. Ltd.
 * ============================================================================
 */
/**
 * @author : Narender - narender@au79consulting.com
 * @Date : 27-02-2025
 * @description : Component to add, update and replace vehicle components.
 */
import {
  Box,
  Card,
  CardContent,
  CardHeader,
  IconButton,
  InputAdornment,
  Menu,
  MenuItem,
  Paper,
  TextField,
  Typography,
} from "@mui/material";
import React, { useEffect, useRef, useState } from "react";
// import { CustomButton, CustomPagination } from "../../components";
// import CustomFiltersN from "../../components/tables/CustomFiltersN";
// import IconListManager from "../../assets/app-theme/appIcons";
import VehicleComponentsAddDialog from "../../components/labcar/VehicleComponentsAddDialog";
import { HandleApiActions, labCar } from "../../redux/actions";
import { useDispatch, useSelector } from "react-redux";
// import { showToastMessage } from "../../redux/actions/actionHandler";
// import customConsole from "../../config/customConsole";
// import appTheme from "../../assets/AppTheme/appTheme";
import {
  vlcCardStyles,
  vlcComponentStyle,
} from "../../components/customComponentsV2/vlc/config/vlcConfig";
import VlcCardHeader from "../../components/customComponentsV2/vlc/cards/VlcCardHeader";
import { Search } from "@mui/icons-material";
import MoreVertIcon from "@mui/icons-material/MoreVert";
import { componentStyle } from "../../config/appTheme";
import AddButtonV2 from "../../components/customComponentsV2/common/button/AddButtonV2";
import VlcCardContent from "../../components/customComponentsV2/vlc/cards/VlcCardContent";
import CustomPaginationV2 from "../../components/customComponentsV2/common/pagination/CustomPaginationV2";
import CustomToolTip from "../../components/infoButton/CustomToolTip";
import { showToastMessage } from "../../redux/actions/actionHandler";
import CustomDialogBoxV2 from "../../components/customComponentsV2/common/customDialogBox/CustomDialogBoxV2";
import DetailsLogTab from "../../components/customComponentsV2/vlc/pages/DetailsLogTab";
import VehicleComponentsEditDialog from "../../components/labcar/VehicleComponentsEditDialog";

function VehicleComponents({
  selectedProjectDetails,
  selectedSingleVariantDetails,
  variantOptionList,
  selectedZoneDetails,
  supplierOptionsList,
  vcOptionsList,
  filterState,
  onFilterChange,
  onClearFilters,
  selectedVehicleSystem,
  s,
}) {
  /**
   * ===================== State Initialization =====================
   */
  /** ============== Redux ============== **/
  const dispatch = useDispatch();
  const selectedVehicleSystemId = useSelector(
    (state) => state.labCarReducer.selectedVehicleSystemId,
  );
  const vehicleComponents = useSelector(
    (state) => state.labCarReducer.vehicleComponents,
  );
  /** ============== Dialogs ============== **/
  const [openAddDialog, setOpenAddDialog] = useState(false);
  /** ============== App Icons ============== **/
  // const { AddIcon } = IconListManager();
  /** ============== Filter ============== **/
  // const [anchorElFilter, setAnchorElFilter] = useState(null);
  // const [openFilter, setOpenFilter] = useState(false);
  const [selectedSearchField, setSelectedSearchField] = useState("name");
  const [searchFieldValue, setSearchFieldValue] = useState("");
  /** ============== Pagination ============== **/
  const [page, setPage] = useState(1);
  const [rowsPerPage, setRowsPerPage] = useState(25);
  const [totalCount, setTotalCount] = useState(0);
  // const [hasMore, setHasMore] = useState(false);

  // recreate states
  const [openRecreationVCDialog, setOpenRecreationVCDialog] = useState(false);
  const [selectedParentVCDetails, setSelectedParentVCDetails] = useState(null);
  const [recreationParentVCList, setRecreationParentVCList] = useState([]);
  const [anchorEl, setAnchorEl] = useState(null);
  const [activeItemId, setActiveItemId] = useState(null);
  const [openVCChangeLogsDialog, setOpenVCChangeLogsDialog] = useState(false);
  const [vcChangeLogsList, setVCChangeLogsList] = useState([]);
  const [vcChangeLogsTotalCount, setVCChangeLogsTotalCount] = useState(0);
  const [vcLogsDialogData, setVCLogsDialogData] = useState(null);
  const [openEditVCDialog, setOpenEditVCDialog] = useState(false);
  const [selectedVCItemForEdit, setSelectedVCItemForEdit] = useState(null);

  // recreate function

  const getParentVCDetails = async () => {
    // api call for getting parent VC components

    let parentVCResponse = await dispatch(
      HandleApiActions({
        ...labCar.get_parent_vc,
        params: {
          project_id: selectedProjectDetails.project_id,
          parent_project_id: selectedProjectDetails.parent_project_id,
          variant_id: selectedSingleVariantDetails.variant_id,
          parent_variant_id:
            selectedSingleVariantDetails?.parent_variant_details?.variant_id,
          vs_id: selectedVehicleSystem.id,
          parent_vs_id: selectedVehicleSystem?.parent_vs_id,
        },
      }),
    );
    if (!parentVCResponse.error) {
      setSelectedParentVCDetails(parentVCResponse.data[0]);
      setRecreationParentVCList(parentVCResponse.data);
      setOpenRecreationVCDialog(true);
    } else {
      showToastMessage({
        type: "error",
        message: parentVCResponse.msg,
      });
      setRecreationParentVCList([]);
      setSelectedParentVCDetails(null);
    }
  };

  const handleVCRecreateOpen = async () => {
    await getParentVCDetails();
  };

  const handleMoreClick = (e, item) => {
    e.stopPropagation();
    setAnchorEl(e.currentTarget);
    setActiveItemId(item?.id);
  };
  const handleCloseMenu = () => {
    setAnchorEl(null);
    setActiveItemId(null);
  };
  const handleGetVehicleComponentChangeLogs = async ({
    pageNo = 1,
    pageSize = 25,
  } = {}) => {
    const entityId = vcLogsDialogData?.id;
    if (!entityId) return;
    const resp = await dispatch(
      HandleApiActions({
        ...labCar.vehicle_component_logs,
        params: {
          entity_id: Number(entityId),
          page_number: pageNo,
          page_size: pageSize,
        },
        show_toast: false,
      }),
    );
    if (resp?.error) {
      setVCChangeLogsList([]);
      setVCChangeLogsTotalCount(0);
      return;
    }
    setVCChangeLogsList(resp?.data || []);
    setVCChangeLogsTotalCount(resp?.total_count || 0);
  };
  const handleVCLogsDialogOpen = (item) => {
    setVCLogsDialogData(item);
    setOpenVCChangeLogsDialog(true);
  };
  const handleVCLogsDialogClose = () => {
    setOpenVCChangeLogsDialog(false);
    setVCLogsDialogData(null);
    setVCChangeLogsList([]);
    setVCChangeLogsTotalCount(0);
  };
  const getVehicleComponentDetailsForEdit = async (item) => {
    const projectId = selectedProjectDetails?.project_id;
    const variantId = selectedSingleVariantDetails?.variant_id;
    const vsId = selectedVehicleSystemId;
    const vcId = item?.id;

    if (!projectId || !variantId || !vsId || !vcId) return item;

    const resp = await dispatch(
      HandleApiActions({
        ...labCar.get_vehicle_components_all,
        show_toast: false,
        params: {
          project_id: Number(projectId),
          variant_id: Number(variantId),
          vs_id: Number(vsId),
          vc_id: Number(vcId),
        },
      }),
    );

    if (resp?.error) return item;
    const matchedComponent = (resp?.data || []).find(
      (vc) =>
        Number(vc?.id) === Number(vcId) || Number(vc?.vc_id) === Number(vcId),
    );
    return matchedComponent || item;
  };

  const handleMenuAction = async (action, item) => {
    handleCloseMenu();
    if (action === "edit") {
      const vcDetails = await getVehicleComponentDetailsForEdit(item);
      setSelectedVCItemForEdit(vcDetails);
      setOpenEditVCDialog(true);
      return;
    }
    if (action === "log") {
      handleVCLogsDialogOpen(item);
    }
  };

  /**
   * ===================== Effect Hooks =====================
   */
  // Fetches vehicle components when any of the dependencies change.
  // Dependencies: pagination, search filters, and selected project/variant detail, selectedVehicleSystemId
  const getVehicleComponents = React.useCallback(async () => {
    const projectId = selectedProjectDetails?.project_id;
    const variantId = selectedSingleVariantDetails?.variant_id;
    const isZonal = selectedProjectDetails?.is_zonal;
    const zonePosition = selectedZoneDetails?.position;
    const vsId = selectedVehicleSystemId;
    // Guard: only fetch when project, variant, and a vehicle system are selected
    if (!projectId || !variantId || !vsId) return;
    // zonePosition can be 0, so check null/undefined explicitly
    if (isZonal && (zonePosition === null || zonePosition === undefined))
      return;
    const apiDetails = labCar.get_vehicle_components;
    const resp = await dispatch(
      HandleApiActions({
        ...apiDetails,
        show_toast: false,
        params: {
          project_id: Number(projectId),
          variant_id: Number(variantId),
          vs_id: Number(vsId),
          ...(isZonal && { zone_position: zonePosition }),
          ...(searchFieldValue && {
            [selectedSearchField]: searchFieldValue,
          }),
          sort_field: filterState.sortField,
          sort_order: filterState.sortOrder,
          ...(filterState.nameFilterSearch && {
            name: filterState.nameFilterSearch,
          }),
          ...(filterState.componentNumFilterSearch && {
            component_number: filterState.componentNumFilterSearch,
          }),
          ...(filterState.descriptionFilterSearch && {
            description: filterState.descriptionFilterSearch,
          }),
          page_number: page,
          page_size: rowsPerPage,
        },
      }),
    );
    if (resp?.error) {
      setTotalCount(0);
      return;
    }

    setTotalCount(Number(resp?.total_count ?? 0));
  }, [
    dispatch,
    selectedProjectDetails?.project_id,
    selectedSingleVariantDetails?.variant_id,
    selectedProjectDetails?.is_zonal,
    selectedZoneDetails?.position,
    selectedVehicleSystemId,
    selectedSearchField,
    searchFieldValue,
    filterState.sortField,
    filterState.sortOrder,
    filterState.nameFilterSearch,
    filterState.componentNumFilterSearch,
    filterState.descriptionFilterSearch,
    page,
    rowsPerPage,
  ]);

  useEffect(() => {
    getVehicleComponents();
  }, [
    page,
    rowsPerPage,
    selectedSearchField,
    searchFieldValue,
    selectedProjectDetails,
    selectedSingleVariantDetails,
    selectedZoneDetails,
    selectedZoneDetails,
    filterState.sortField,
    filterState.sortOrder,
    filterState.nameFilter,
    filterState.componentNumFilter,
    filterState.descriptionFilter,
    filterState.nameFilterSearch,
    filterState.componentNumFilterSearch,
    filterState.descriptionFilterSearch,
    selectedVehicleSystemId,
    getVehicleComponents,
  ]);
  // Resets filters/patination when any of the dependencies change.
  // Dependencies: selected project and selected single variant details.
  useEffect(() => {
    // Reset filters/pagination when project/variant or vehicle system changes
    setSelectedSearchField("name");
    setSearchFieldValue("");
    // setRowsPerPage(25);
    setPage(1);
  }, [
    selectedProjectDetails,
    selectedSingleVariantDetails,
    selectedVehicleSystemId,
  ]);


  /**
   * ===================== API Call Functions =====================
   */
  /**
   * @author : Narender
   * @Date : 03-03-2025
   * @description : Fetches vehicle components
   * @param {project_id, variant_id, vs_id, selectedSearchField, searchFieldValue, page_number, page_size}
   * @return {msg: "", data: [], error: true | false}
   */
  // Fetch handled in memoized getVehicleComponents above


  /** ============== Pagination ============== **/
  // Updates the current page
  const handlePageChange = (value) => setPage(value);
  const [nameSearch, setNameSearch] = useState("");
  const debounceRef = useRef();

  useEffect(() => {
    if (debounceRef.current) {
      clearTimeout(debounceRef.current);
    }

    if (nameSearch.length >= 3 || nameSearch.length === 0) {
      debounceRef.current = setTimeout(() => {
        setSelectedSearchField("name");
        setSearchFieldValue(nameSearch);
        setPage(1);
      }, 500);
    }
    return () => {
      if (debounceRef.current) {
        clearTimeout(debounceRef.current);
      }
    };
  }, [nameSearch]);

  return (
    <Box>
      {/* Vehicle components card */}
      <Box
        sx={{
          flex: 1,
          minWidth: 0,
          minHeight: 0,
          display: "flex",
          flexDirection: "column",
        }}
      >
        <Card
          sx={{
            ...vlcComponentStyle.card,
            display: "flex",
            flexDirection: "column",
            height: "450px",
          }}
        >
          <CardHeader
            sx={vlcComponentStyle.cardHeader}
            title={
              <VlcCardHeader
                title={"Vehicle Components"}
                showRecreateIcon={
                  selectedProjectDetails?.parent_project_id &&
                    selectedSingleVariantDetails?.parent_variant_details
                      ?.variant_id &&
                    selectedVehicleSystem?.parent_vs_id
                    ? true
                    : false
                }
                onRecreateClick={handleVCRecreateOpen}
              >
                <Box
                  display="flex"
                  justifyContent="center"
                  alignItems="center"
                  gap={1}
                  sx={{
                    width: "100%",
                    mt: 1,
                  }}
                >

                  <TextField
                    size="small"
                    placeholder="Search Name"
                    variant="outlined"
                    fullWidth
                    value={nameSearch}
                    onChange={(e) => setNameSearch(e.target.value)}
                    InputProps={{
                      startAdornment: (
                        <InputAdornment position="start">
                          <Search fontSize="small" />
                        </InputAdornment>
                      ),

                    }}
                    sx={componentStyle.searchField.textField}
                  />
                  <Box>
                    <AddButtonV2
                      handleOnClick={(e) => setOpenAddDialog(true)}
                      disabled={!selectedVehicleSystemId}
                    />
                  </Box>
                </Box>
              </VlcCardHeader>
            }

          />
          <CardContent
            sx={{
              ...vlcCardStyles.CardContent,
              flex: 1,
              minHeight: 0,
              overflowY: "auto",
              p: 0,
              scrollbarColor: "#888 #f1f1f1",
              scrollbarWidth: "thin",
              "&::-webkit-scrollbar": {
                width: "8px",
              },
              "&::-webkit-scrollbar-track": {
                background: "#f1f1f1",
              },
              "&::-webkit-scrollbar-thumb": {
                background: "#888",
                borderRadius: "4px",
              },
              "&::-webkit-scrollbar-thumb:hover": {
                background: "#555",
              },
              // backgroundColor: "#0000ff",
            }}
          >
            {selectedVehicleSystemId &&
              vehicleComponents &&
              vehicleComponents?.length > 0 ? (
              vehicleComponents?.map((item, index) => (
                <VlcCardContent key={item.id} onClick={() => { }} data={item}>
                  <Box
                    sx={{
                      width: "100%",
                      display: "flex",
                      justifyContent: "space-between",
                      alignItems: "flex-start",
                    }}
                  >
                    <Box
                      sx={{
                        display: "flex",
                        flexDirection: "column",
                        alignItems: "flex-start",
                        p: 1,
                        width: "90%",
                      }}
                    >
                      <Typography
                        sx={{
                          ...componentStyle.font.text,
                          overflow: "hidden",
                          textOverflow: "ellipsis",
                          whiteSpace: "nowrap",
                          maxWidth: "100%",
                        }}
                      >
                        <CustomToolTip
                          type="string"
                          length={60}
                          style={{
                            ...componentStyle.font.text,
                            overflow: "hidden",
                            textOverflow: "ellipsis",
                            whiteSpace: "nowrap",
                            maxWidth: "100%",
                            fontWeight: "bold",
                          }}
                          title={`Name: ${item?.name ?? ""}`}
                        >
                          {`Name: ${item?.name ?? ""}`}
                        </CustomToolTip>
                      </Typography>
                      <Typography
                        sx={{
                          ...componentStyle.font.text,
                          overflow: "hidden",
                          textOverflow: "ellipsis",
                          whiteSpace: "nowrap",
                          maxWidth: "100%",
                          color: vlcCardStyles.vlcCardListColor,
                        }}
                      >
                        <CustomToolTip
                          type="string"
                          length={60}
                          style={{
                            ...componentStyle.font.text,
                            overflow: "hidden",
                            textOverflow: "ellipsis",
                            whiteSpace: "nowrap",
                            maxWidth: "100%",
                          }}
                          title={`Component No: ${item?.component_number ?? ""}`}
                        >
                          {`Component No: ${item?.component_number ?? ""}`}
                        </CustomToolTip>
                      </Typography>
                      <Typography
                        sx={{
                          ...componentStyle.font.text,
                          overflow: "hidden",
                          textOverflow: "ellipsis",
                          whiteSpace: "nowrap",
                          maxWidth: "100%",
                          color: vlcCardStyles.vlcCardListColor,
                        }}
                      >
                        <CustomToolTip
                          type="string"
                          length={60}
                          style={{
                            ...componentStyle.font.text,
                            overflow: "hidden",
                            textOverflow: "ellipsis",
                            whiteSpace: "nowrap",
                            maxWidth: "100%",
                          }}
                          title={`Description: ${item?.description ?? ""}`}
                        >
                          {`Description: ${item?.description ?? ""}`}
                        </CustomToolTip>
                      </Typography>
                    </Box>
                    <Box sx={{ pr: 1, pt: 1 }}>
                      <IconButton
                        size="small"
                        sx={{ color: "black" }}
                        onClick={(e) => handleMoreClick(e, item)}
                      >
                        <MoreVertIcon sx={{ fontSize: "18px" }} />
                      </IconButton>
                      <Menu
                        anchorEl={anchorEl}
                        open={Boolean(anchorEl) && activeItemId === item?.id}
                        onClose={handleCloseMenu}
                        PaperProps={{
                          sx: {
                            borderRadius: 0,
                            boxShadow: 1,
                          },
                        }}
                      >
                        <MenuItem
                          onClick={() => handleMenuAction("edit", item)}
                          sx={{ ...componentStyle.font.cardText }}
                        >
                          Edit details
                        </MenuItem>
                        <MenuItem
                          onClick={() => handleMenuAction("log", item)}
                          sx={{ ...componentStyle.font.cardText }}
                        >
                          Log
                        </MenuItem>
                      </Menu>
                    </Box>
                  </Box>
                </VlcCardContent>
              ))
            ) : (
              <Typography variant="body1" sx={styles.noDataAvailable}>
                No data available
              </Typography>
            )}
          </CardContent>
          {/* ============== Pagination ============== */}
          <Paper
            sx={{
              display: "flex",
              justifyContent: "flex-end",
              alignItems: "center",
              // p: { xs: "2px", sm: "3px" },
              minHeight: "40px",
              borderTop: "1px solid #ddd",
              borderRadius: "0px !important",
            }}
          >
            {/* <CustomPagination
              page={page}
              rowsPerPage={rowsPerPage}
              onPageChange={handlePageChange}
              onPageSizeChange={handlePageSizeChange}
              hasMore={hasMore}
            /> */}
            {/* {JSON.stringify(totalEECount)} */}
            {(totalCount || vehicleComponents?.length || 0) > 0 && (
              <CustomPaginationV2
                page={page}
                rowsPerPage={rowsPerPage}
                onPageChange={handlePageChange}
                totalItems={Math.max(
                  totalCount || 0,
                  vehicleComponents?.length || 0,
                )}
              />
            )}
          </Paper>
        </Card>
      </Box>
      {/* ============== Dialogs ============== */}
      {/* Add vehicle component dialog */}
      <VehicleComponentsAddDialog
        openDialog={openAddDialog}
        setOpenDialog={setOpenAddDialog}
        title={"Add Vehicle Component"}
        variantOptionList={variantOptionList}
        selectedProjectDetails={selectedProjectDetails}
        selectedSingleVariantDetails={selectedSingleVariantDetails}
        supplierOptionsList={supplierOptionsList}
        vcOptionsList={vcOptionsList}
        getVehicleComponents={getVehicleComponents}
      />

      {/* Recreate dialog */}
      <VehicleComponentsAddDialog
        openDialog={openRecreationVCDialog}
        setOpenDialog={setOpenRecreationVCDialog}
        title={"Recreate Vehicle Component"}
        variantOptionList={variantOptionList}
        selectedProjectDetails={selectedProjectDetails}
        selectedSingleVariantDetails={selectedSingleVariantDetails}
        supplierOptionsList={supplierOptionsList}
        vcOptionsList={vcOptionsList}
        getVehicleComponents={getVehicleComponents}
        recreationMode={true}
        recreationParentVCList={recreationParentVCList}
        selectedParentVCDetails={selectedParentVCDetails}
        setSelectedParentVCDetails={setSelectedParentVCDetails}
      />
      <VehicleComponentsEditDialog
        openDialog={openEditVCDialog}
        setOpenDialog={setOpenEditVCDialog}
        selectedVCItem={selectedVCItemForEdit}
        variantOptionList={variantOptionList}
        selectedProjectDetails={selectedProjectDetails}
        selectedSingleVariantDetails={selectedSingleVariantDetails}
        supplierOptionsList={supplierOptionsList}
        vcOptionsList={vcOptionsList}
        selectedVehicleSystemId={selectedVehicleSystemId}
        selectedVehicleSystemDetails={selectedVehicleSystem}
        getVehicleComponents={getVehicleComponents}
      />
      <CustomDialogBoxV2
        open={openVCChangeLogsDialog}
        onClose={handleVCLogsDialogClose}
        title={"Vehicle Components"}
      >
        <Box sx={{ width: "450px", height: "500px" }}>
          <DetailsLogTab
            logData={vcLogsDialogData}
            ChangeLogsList={vcChangeLogsList}
            getLogsData={handleGetVehicleComponentChangeLogs}
            selectedComponent={vcLogsDialogData}
            zone_name={vcLogsDialogData?.zone_details?.zone_name}
            variantOptionList={variantOptionList}
            selectedSingleVariantDetails={selectedSingleVariantDetails}
            openEditDetailsDialog={openVCChangeLogsDialog}
            setOpenEditDetailsDialog={setOpenVCChangeLogsDialog}
            totalLogsCount={vcChangeLogsTotalCount}
            type={"VC"}
          />
        </Box>
      </CustomDialogBoxV2>
    </Box>
  );
}

export default VehicleComponents;

// Styles
const styles = {
  vsContainer: {
    flex: 1,
    minWidth: 0,
    minHeight: { xs: "350px", sm: "400px", md: "500px" },
    maxHeight: { xs: "500px", sm: "600px", md: "700px" },
    width: "100%",
    display: "flex",
    flexDirection: "column", // changed from "row" to "column"
    alignItems: "stretch",
    justifyContent: "stretch",
    height: "100%", // ensure full height
    boxSizing: "border-box",
  },
  card: {
    flex: 1,
    minWidth: 0,
    width: "100%",
    maxWidth: "100%",
    height: "100%",
    boxShadow: 4,
    borderRadius: "3%",
    display: "flex",
    flexDirection: "column",
  },
  cardHeader: {
    py: { xs: 0.3, sm: 0.5 },
    backgroundColor: "lightgrey",
    borderBottom: "1px solid lightgrey",
    borderRadius: "2%",
  },
  cardContent: {
    flex: 1,
    minHeight: 0,
    overflowY: "auto",
    scrollbarColor: "#888 #f1f1f1",
    scrollbarWidth: "thin",
    px: { xs: 0.5, sm: 1 },
    py: { xs: 0.5, sm: 1 },
  },
  paginationPaper: {
    display: "flex",
    justifyContent: "flex-end",
    p: { xs: "2px", sm: "3px" },
  },
  noDataAvailable: {
    textAlign: "center",
    mt: { xs: 1, sm: 2 },
    fontSize: { xs: "0.9rem", sm: "1rem" },
  },
  cardContentCards: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    mb: { xs: 0.5, sm: 1 },
    pl: { xs: 0.5, sm: 1 },
    pr: { xs: 0.2, sm: 0.5 },
    backgroundColor: "background.paper",
    borderRadius: 2,
    boxShadow: 1,
    cursor: "pointer",
    minHeight: { xs: 44, sm: 54 },
    maxWidth: "100%",
    "&:hover": {
      backgroundColor: "#f0f0f0",
    },
    border: "1px solid lightgrey",
  },
  cardContentCardContainer: {
    // flexGrow: 1,
    textAlign: "start",
    my: { xs: 0.5, sm: 1 },
    flex: 1,
    minWidth: 0,
    overflow: "hidden",
    // display: "flex",
    // flexDirection: "column",
    gap: 0.5,
    // fontSize: { xs: "0.75rem", sm: "0.85rem" },
  },
};
